import createAuth from "./createAuth";
import authorizationCode from "./authorizationCode";
const authenticate = async _ref => {
  let {
    type,
    config,
    scope,
    code,
    refreshToken
  } = _ref;
  const auth = createAuth(config);
  let authRes = null;
  const opts = {
    scopes: scope
  };
  if (type === "clientCredentials" && (authRes = await auth.credentials.getToken(opts)), type === "refreshToken" && refreshToken && (authRes = await auth.createToken("", refreshToken, "refresh_token", {}).refresh()), type === "owner" && (authRes = await auth.owner.getToken(config.username, config.password, opts)), type === "authorizationCode") {
    const uri = auth.code.getUri();
    authRes = await authorizationCode(auth, uri, code);
  }
  return authRes;
};
export default authenticate;